import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

export function scheduleStartDateFromUTC(startDate: string) {
  if (!startDate) {
    return undefined
  }

  return stringToDate(startDate, 'backend_datetime_without_timezone')
}

type ScheduleDates = {
  startDate?: string | null
  startTime?: string | null
}
